<div class="registration-container">
  <div class="hero">
    <!-- <div>
      <div class="image">
        <img src="/assets/tytnetwork-light-shadow.png" />
        <div class="tagline">7 Billion Views | 6 Million Subscribers</div>
      </div>
      <div class="flex-spacer"></div>
      <div class="sign-in">

      </div>
    </div> -->
  </div>
  <div class="my-profile" *ngIf="user">
    <div class="form-title">Cancel Membership</div>

    <ng-container *ngIf="user.membership.gateway_name == 'free' && user.membership.gift_item">
        <div class="info-text">
          Your membership is a time-limited gift from {{user.membership.gift_item.purchaser_name}},
          so there is nothing to cancel. If you do not wish to use your gift, you can let it expire as normal.
          
          <br/><br/>
          <a routerLink="/account">Back to My Account</a>
          
        </div>
    </ng-container>
    <ng-container *ngIf="user.membership.gateway_name == 'stripe' && user.membership.gift_item">
        <div class="info-text">
          Your membership is an ongoing gift from {{user.membership.gift_item.purchaser_name}}.
          The purchasing user must take action to cancel this membership. 
          
          <br/><br/>

          Please contact support@tytnetwork.com if you require assistance with your ongoing gift membership.

          <br/><br/>

          <a routerLink="/account">Back to My Account</a>
          
        </div>
    </ng-container>
    <ng-container *ngIf="user.membership.gateway_name == 'paypal_subscription'">
        <div class="info-text">
          Your current payment method is PayPal. Due to the type of membership you have, you will have to contact Member 
          Services at <a target="_blank" href="support@tytnetwork.com">support@tytnetwork.com</a> if you wish to 
          cancel your membership. Sorry for the inconvenience, and thank you for supporting TYT Network.
          <br/><br/>
          <a routerLink="/account">Back to My Account</a>
          
        </div>
    </ng-container>

    <ng-container *ngIf="user.membership.gateway_name == 'iap_apple'">
        Membership subscriptions purchased through the App Store can only be cancelled by signing in to your
        <a target="_blank" href="https://buy.itunes.apple.com/WebObjects/MZFinance.woa/wa/DirectAction/manageSubscriptions">iOS App Store Account</a>,
        clicking on Subscriptions, and then clicking on TYT Plus from Active Subscriptions.

        <br/><br/>
        <a routerLink="/account">Back to My Account</a>
    </ng-container>

    <ng-container *ngIf="user.membership.gateway_name == 'google_play'">
        Membership subscriptions purchased through the Google Play Store can only be cancelled by signing in to your 
        <a target="_blank" href="https://play.google.com/store/account/subscriptions">Google Play Store Account</a>, clicking on My Subscriptions, 
        and then clicking on TYT Plus from the list displayed under My Subscriptions.<br/><br/>

        For more information about how to do this, see this 
        <a target="_blank" href="https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=en">Google Play support article</a>.

        <br/><br/>
        <a routerLink="/account">Back to My Account</a>
    </ng-container>

    <ng-container *ngIf="!user.membership.gift_item && (user.membership.gateway_name == 'stripe' || user.membership.gateway_name == 'paypal_agreement')">
      <img src="/assets/before-you-go.jpg" class="cenk-confused" />
      <h5 class="header-title">Please Reconsider, <em>You are TYT.</em></h5>
      <div class="description">
        TYT membership is what keeps TYT on-air reaching millions with progressive views on issues that impact us all.
      </div>

      <div class="description">
        Together we amplify our unapologetically progressive message and our demands for single-payer health care, 
        for criminal justice reform, for ending imperialist wars, for racial justice, for decisive action on climate 
        change and for an end to money's corrupting influence on our politics.
      </div>

      <div class="description">
        Still want to go?
      </div>

      <div class="description">
        Please let us know why you are leaving and how we can improve?
      </div>

      <div class="help-center">
        Maybe you've got questions too. Have you tried our <a href="https://help.tyt.com/" target="_blank">help center</a>?
      </div>
      
      <app-form #form action="/membership/cancel" [handler]="this" class="form-fields">
        <div class="form-group text-field">
          <select class="form-control" id="reason" name="reason" [(ngModel)]="reason">
            <option value="" selected>Select the reason why you are leaving</option>
            <!-- <option value="I don't use my membership enough">I don't use my membership enough</option>
            <option value="I can't afford membership anymore">I can't afford membership anymore</option>
            <option value="I'm no longer interested">I'm no longer interested</option>
            <option value="Technical Issue">Technical Issue</option> -->
            <option *ngFor="let item of reasonList" value={{item.key}}>
              {{ item.reason }}
            </option>
          </select>
        </div>

        <div class="form-group text-field">
          <span for="feedback">Please feel free to provide any details or feedback. We read every single comment.</span>
          <textarea class="form-control" rows="4" id="feedback" id="feedback" name="feedback" value="feedback" [(ngModel)]="feedback"></textarea>
        </div>

        <tyt-staging-note *ngIf="checkboxCancel" class="checkbox test-only">
          <label><input type="checkbox" [(ngModel)]="immediateCancel">Immediately cancel membership</label>
        </tyt-staging-note>

        <div class="actions">
          <app-form-submit-button [hideArrow]="true">Cancel Membership</app-form-submit-button>
          <a href="javascript:;" (click)="toPrevious()">
            Keep Membership
            <i class="fa fa-arrow-right"></i>
          </a>

          <!-- <button class="d-block sign-in btn btn-danger mx-auto save">Cancel Membership</button>
          <button type="button" (click)="toPrevious()" class="d-block sign-in btn btn-primary mx-auto cancel">Keep</button> -->
        </div>
        
      </app-form>
    </ng-container>
  </div>

  <div class="backButton" *ngIf="user && user.membership && !user.membership.gift_item && (user.membership.gateway_name == 'stripe' || user.membership.gateway_name == 'paypal_agreement')">
    <a routerLink="/account">Back to your account</a>
  </div>
</div>